define( [
	"./document"
], function( document ) {
	"use strict";

	return document.documentElement;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/documentElement.js
// module id = 77
// module chunks = 27